// @ts-nocheck
// FILE IS AUTO-GENERATED AND WILL BE OVERWRITTEN

import app_serverResources from "./app_serverResources"
import DataTypesResources from "./DataTypesResources"
import AbsencesResources from "./AbsencesResources"


declare module "i18next" {
  interface CustomTypeOptions {
    resources: {
  app_server: app_serverResources;
  DataTypes: DataTypesResources;
  Absences: AbsencesResources;
}
}
}


export const supportedLngs = ["de", "en", ];


export const ns = ["app_server", "DataTypes", "Absences", ];

